/** @jsxImportSource react */
import type { SVGProps } from 'react';
const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M9.97 18.53a.75.75 0 1 0 1.06-1.06l-4.72-4.72H19.5a.75.75 0 0 0 0-1.5H6.31l4.72-4.72a.75.75 0 1 0-1.06-1.06l-6 6a.75.75 0 0 0 0 1.06z"
    />
  </svg>
);
export default ArrowLeft;
